import { render, staticRenderFns } from "./DestaquesCarousel.vue?vue&type=template&id=885852ae&scoped=true&"
import script from "./DestaquesCarousel.vue?vue&type=script&lang=js&"
export * from "./DestaquesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DestaquesCarousel.vue?vue&type=style&index=0&id=885852ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885852ae",
  null
  
)

export default component.exports